var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import omit from 'lodash/omit';
import * as React from 'react';
import { StyledDropdown } from './style';
var ExtendDropdown = /** @class */ (function (_super) {
    __extends(ExtendDropdown, _super);
    function ExtendDropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (event, data) {
            _this.setState({
                value: data.value,
            });
            _this.props.onChange && _this.props.onChange(event, data);
        };
        _this.state = {
            value: _this.props.value ? _this.props.value : undefined,
        };
        return _this;
    }
    ExtendDropdown.prototype.render = function () {
        var props = omit(this.props, [
            'inverted',
            'checkEmpty',
            'center',
            'required',
        ]);
        var isRequired = !this.state.value && this.props.required;
        if (this.props.required) {
            return React.createElement("div", { style: { position: 'relative', display: 'inline-block', width: '100%' } },
                React.createElement(StyledDropdown, __assign({}, props, { onChange: this.handleChange })),
                React.createElement("input", { type: "text", required: isRequired, style: { position: 'absolute', top: '0px', opacity: 0, width: '100%', left: '0px', height: '45px', zIndex: -1 } }));
        }
        return React.createElement(StyledDropdown, __assign({}, props));
    };
    return ExtendDropdown;
}(React.Component));
export default ExtendDropdown;
//# sourceMappingURL=dropdown.js.map